export default __webpack_public_path__ + "static/media/Lato-Light.ae6d2457.woff2";